import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FeedbackDialog = ({ open, onOpenChange }) => {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) {
      toast.error("Vul een bericht in");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/feedback`, { message: message.trim() });
      toast.success("Bedankt voor je melding!");
      setMessage("");
      onOpenChange(false);
    } catch {
      toast.error("Verzenden mislukt, probeer het later opnieuw");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Fout of idee melden</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <p className="text-sm text-slate-600 leading-relaxed">
            Beschrijf hier de fout in de applicatie of jouw idee om Sportly Hockey Planner beter te maken (max 350 karakters).
          </p>
          <div className="relative">
            <Textarea
              value={message}
              onChange={(e) => setMessage(e.target.value.slice(0, 350))}
              placeholder="Beschrijf de fout of je idee..."
              className="min-h-[120px] resize-none"
              data-testid="feedback-input"
            />
            <span className="absolute bottom-2 right-3 text-xs text-slate-400">
              {message.length}/350
            </span>
          </div>
          <Button
            onClick={handleSubmit}
            disabled={sending || !message.trim()}
            className="w-full bg-slate-900 hover:bg-slate-800 h-11"
            data-testid="feedback-submit-btn"
          >
            {sending ? "Verzenden..." : "Verzenden"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
